import React from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import Pagination from '~components/atoms/Pagination';
import combinedActions from '~redux/combinedActions';

const APIKeyHistoryTablePagination = () => {
    const isLoading = useAppSelector(state => state.setting.loadings.getSilverApiKeyHistoryListing);
    const { index, maxIndex } = useAppSelector(state => state.setting.silverApiKeyHistoryListing);

    const dispatch = useAppDispatch();

    const setIndex = (newIndex: number) => {
        if (isLoading) return;

        dispatch(combinedActions.settingSetGetSilverAPIKeyHistoryListingIndex({ index: newIndex }));
    };

    const handleOnPrev = () => {
        if (index > 0) setIndex(index - 1);
    };
    const handleOnNext = () => {
        if (index < maxIndex) setIndex(index + 1);
    };
    const handleOnFirst = () => setIndex(0);
    const handleOnLast = () => setIndex(maxIndex >= 0 ? maxIndex : 0);

    return (
        <Pagination
            currentPage={index}
            maxPage={maxIndex}
            onPrev={handleOnPrev}
            onNext={handleOnNext}
            onFirst={handleOnFirst}
            onLast={handleOnLast}
        />
    );
};

export default APIKeyHistoryTablePagination;
